import React, { Fragment, useEffect, useState } from 'react';
import './Dashboard.css';
import { getMostRecentPrimaryInterviewTaxYearState, getConfirmAuthorizeState } from '../../../../../utils/CaseStateUtilities';
import { useSelector, useDispatch } from 'react-redux';
import ConfirmAuthorize from './DocumentsSection/ConfirmAuthorize'
import TaxYearSection from '../../../../../components/Workflow/TaxYearSection/TaxYearSection';
import POMSection from '../../../../../components/Workflow/POM/POMSection';
import AdditionalDocumentsSection from '../../../../../components/Workflow/AdditionalDocuments/AdditionalDocumentsSection';
import { ValidTicketTypes } from '../../../../../../src/hooks/useTicketTypeHook';
import ProductActions from '../../../../../../src/reducers/productsRedux';
import { 
    hasSignatureDocuments, 
    hasOtherAdditionalDocuments, 
    hasPOMDocuments, 
    isInPaymentState, 
    isInPreparePaymentState, 
    isInFileState 
} from '../../../../../utils/WorkflowUtil';
import { getIcon } from '../../../../../utils/IconUtil';
import T from 'i18n-react';
import { isReviewTask, WorkflowTasks } from '../../../../../utils/WorkflowTasks';
import SurveyLinkSection from '../../../../../components/Workflow/TaxYearSection/SurveyLinkSection'

const WorkflowLinearSteps = (props) => {
    const dispatch = useDispatch();
    var primaryInterviewTaxYearState = getMostRecentPrimaryInterviewTaxYearState(props.caseState);
    var confirmAuthorizeState = getConfirmAuthorizeState(props.caseState, props.taxState?.taxYear);
    const lang = useSelector(state => state.layout?.lang)
    const currentTaxYear = useSelector(state => state.layout?.currentTaxYear)
    const layoutType = useSelector(state => state.layout?.layoutType)
    var showConfirm = confirmAuthorizeState ? confirmAuthorizeState.primaryShowConfirm || confirmAuthorizeState.spouseShowConfirm : false;
    var showAuthorize = confirmAuthorizeState ? confirmAuthorizeState.primaryShowAuthorize || confirmAuthorizeState.primaryAuthorizeAddedQC || confirmAuthorizeState.spouseShowAuthorize : false;
    
    const documents = useSelector(state => state.documents?.documents) || [];
    
    const paymentInfo = useSelector(state => state.payment?.paymentInfo)
    const firstName = useSelector(state => state.accountData?.firstName)
    const addOnProducts = useSelector(state => state.products.addOnProducts)
    
    const [isDocumentsActionRequired, setDocumentsActionRequired] = useState(false)
    const [isReviewReturnActionRequired, setIsReviewReturnActionRequired] = useState(false)
    const [isPaymentActionRequired, setIsPaymentActionRequired] = useState(false)

    const [isDocumentsCompleteOpen, setIsDocumentsCompleteOpen] = useState(false)
    const [isReviewReturnCompleteOpen, setIsReviewReturnCompleteOpen] = useState(false)
    const [isPaymentCompleteOpen, setIsPaymentCompleteOpen] = useState(false)

    const [isDocumentCompleteClosed, setIsDocumentCompleteClosed] = useState(false)
    const [isReviewReturnCompleteClosed, setIsReviewReturnCompleteClosed] = useState(false)
    
    const [showSurvey, setShowSurvey] = useState(true);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        dispatch(ProductActions.getAddOnProducts(props.taxState.workflow_state.case_id));

        const isPaymentTaskPending = props.taxState?.ticketTasks?.filter(x => x.taskId === WorkflowTasks.PAYMENT_RECEIVED && x.target === '1' && !x.isCompleted).length > 0;
        const hasSignatureDocs = hasSignatureDocuments(props.taxState);

        setDocumentsActionRequired(showConfirm || showAuthorize || hasSignatureDocs || (props.taxState?.ticketTasks?.filter(x => x.taskId === WorkflowTasks.DOCS_UPLOADED && !x.isCompleted).length > 0))
        setIsReviewReturnActionRequired(
            props.taxState?.ticketTasks?.filter(x => x.target === '1' && !x.isCompleted && isReviewTask(x.taskId)).length > 0 ||
            hasOtherAdditionalDocuments(props.taxState)
        );
        setIsPaymentActionRequired(isPaymentTaskPending || (isInPaymentState(props.taxState) || hasPOMDocuments(props.taxState)))

        setIsDocumentsCompleteOpen((props.taxState?.ticketState?.includes('_WORKING') || props.taxState?.ticketState?.includes('_DOCUMENT_REVIEW')) && props.taxState?.workflow_state?.upload_docs === 'Complete') 

        setIsReviewReturnCompleteOpen(isInPreparePaymentState(props.taxState) || isInPaymentState(props.taxState) || isInFileState(props.taxState))
        setIsPaymentCompleteOpen(isInFileState(props.taxState) && !isPaymentTaskPending)


        setIsDocumentCompleteClosed((props.taxState?.ticketState?.includes('_REVIEW') || isInPreparePaymentState(props.taxState) || isInPaymentState(props.taxState) || isInFileState(props.taxState)) && props.taxState?.workflow_state.upload_docs === 'Complete' && !showConfirm && !showAuthorize && !hasSignatureDocs)
        setIsReviewReturnCompleteClosed(props.taxState?.workflow_state?.review_return === 'Hide' &&  (props.taxState?.ticketState?.startsWith("RTE_PAYMENT") || isInFileState(props.taxState)))
        
        // Backend calculates if survey should be shown (90 days from payment completion)
        setShowSurvey(props.taxState?.show_survey || false);
    }, [props.taxState])
    
    const fadeOut = () => {}

    return (
        <div className='wf-steps-container'>
            <div className='wf-steps-section-wrapper'>
                <div className='wf-linear-wrapper'> 
                    <img src={isDocumentsActionRequired ? getIcon('client-action-required') : (isDocumentsCompleteOpen || isDocumentCompleteClosed) ? (isDocumentsCompleteOpen ? getIcon('complete-active') : getIcon('complete-inactive')) : getIcon('not-started')} alt="dot" />
                    <div className='wf-steps-connecting-line'></div>
                </div>
                { isDocumentsActionRequired || isDocumentsCompleteOpen ?
                    <div className='wf-steps-section'>
                        <div className='wf-steps-section-title'>{T.translate('WorkflowLinear.workflowStepTitle_Document')}</div>
                        { isDocumentsActionRequired && <div className='wf-steps-section-subtitle'>{ hasSignatureDocuments(props.taxState) ? T.translate('WorkflowPanel.AuthorizationRequest.title') : T.translate('WorkflowLinear.worflowStepSubTitle_Document')}</div>}
                        {primaryInterviewTaxYearState !== null && 
                            <Fragment>
                                <ConfirmAuthorize
                                    confirmAuthorizeState={confirmAuthorizeState}
                                    onWorkflowButtonAction={props.handleWorkflowButton}
                                    onFadeOut={fadeOut}
                                    ticketType={ValidTicketTypes.RTE}
                                />
                                <TaxYearSection
                                    securityComplete={!showConfirm && !showAuthorize && !hasSignatureDocuments(props.taxState)}
                                    taxState={props.taxState} lang={lang}
                                    currentYear={currentTaxYear}
                                    onWorkflowButtonAction={props.handleWorkflowButton}
                                    paymentInfo={paymentInfo}
                                    section="documents"
                                />
                                <POMSection layoutType={layoutType} taxState={props.taxState}
                                    firstName={firstName} addOnProducts={addOnProducts}
                                />
                            </Fragment>
                        }
                    </div>  
                    :
                    <div className='wf-steps-section'>
                        <div className='wf-steps-section-title-inactive'>{T.translate('WorkflowLinear.workflowStepTitle_Document')}</div>
                    </div>
                }
            </div>
            <div className='wf-steps-section-wrapper'>
                <div className='wf-linear-wrapper'> 
                    <img src={isReviewReturnActionRequired ? getIcon('client-action-required') : isPaymentActionRequired || isPaymentCompleteOpen ? getIcon('complete-inactive') : isReviewReturnCompleteOpen ? getIcon('complete-active') : isReviewReturnCompleteClosed ? getIcon('complete-inactive') : getIcon('not-started')} alt="dot" />
                    <div className='wf-steps-connecting-line'></div>
                </div>
                { (isReviewReturnActionRequired || isReviewReturnCompleteOpen) && !isPaymentActionRequired && !isPaymentCompleteOpen ?
                    <div className='wf-steps-section'>
                        <div className='wf-steps-section-title'>{T.translate('WorkflowLinear.workflowStepTitle_ReviewReturn')}</div>
                        { isReviewReturnActionRequired && <div className='wf-steps-section-subtitle'>{T.translate('WorkflowLinear.worflowStepSubTitle_ReviewReturn', { TaxYear : props.taxState.taxYear })}</div>}
                        {primaryInterviewTaxYearState !== null && 
                            <Fragment>
                                <TaxYearSection
                                    securityComplete={!showConfirm && !showAuthorize}
                                    taxState={props.taxState} lang={lang}
                                    currentYear={currentTaxYear}
                                    onWorkflowButtonAction={props.handleWorkflowButton}
                                    paymentInfo={paymentInfo}
                                    section="review"
                                />
                                <AdditionalDocumentsSection lang={lang}
                                    securityComplete={true}
                                    taxState={props.taxState} currentYear={currentTaxYear}
                                    onWorkflowButtonAction={props.handleWorkflowButton}
                                    layoutType={layoutType}
                                />
                            </Fragment>
                        }
                    </div>  
                    :
                    <div className='wf-steps-section'>
                        <div className='wf-steps-section-title-inactive'>{T.translate('WorkflowLinear.workflowStepTitle_ReviewReturn')}</div>
                    </div>
                }
            </div>
            <div className='wf-steps-section-wrapper'>
                <div className='wf-linear-wrapper'> 
                    <img src={isPaymentActionRequired ? getIcon('client-action-required') : isPaymentCompleteOpen ? getIcon('complete-active') : getIcon('not-started')} alt="dot" />
                    <div className='wf-steps-connecting-line'></div>
                </div>
                { isPaymentActionRequired || isPaymentCompleteOpen ?
                    <div className='wf-steps-section'>
                        <div className='wf-steps-section-title'>{T.translate('WorkflowLinear.workflowStepTitle_Payment')}</div>
                        {((paymentInfo?.length > 0 && paymentInfo.some(payment => payment.caseId === props.taxState?.workflow_state?.case_id && !payment.isPaid)) || hasPOMDocuments(props.taxState)) && <div className='wf-steps-section-subtitle'>{T.translate('WorkflowLinear.worflowStepSubTitle_Payment')}</div>}
                        {primaryInterviewTaxYearState !== null && 
                            <Fragment>
                                <TaxYearSection
                                    securityComplete={!showConfirm && !showAuthorize}
                                    taxState={props.taxState} lang={lang}
                                    currentYear={currentTaxYear}
                                    onWorkflowButtonAction={props.handleWorkflowButton}
                                    paymentInfo={paymentInfo}
                                    section={(!paymentInfo || paymentInfo.length === 0) && isPaymentActionRequired ? "manual_payment" : (props.taxState?.primary_province === 'QC' ? "payment_qc" : "payment")}
                                />
                                <AdditionalDocumentsSection lang={lang}
                                    securityComplete={true}
                                    taxState={props.taxState} currentYear={currentTaxYear}
                                    onWorkflowButtonAction={props.handleWorkflowButton}
                                    layoutType={layoutType}
                                />
                                {(!isPaymentActionRequired && isPaymentCompleteOpen && showSurvey) && <SurveyLinkSection taxState={props.taxState} />}
                            </Fragment>
                        }
                    </div>  
                    :
                    <div className='wf-steps-section'>
                        <div className='wf-steps-section-title-inactive'>{T.translate('WorkflowLinear.workflowStepTitle_Payment')}</div>
                    </div>
                }
            </div>
            <div className='wf-steps-section-wrapper'>
                <div className='wf-linear-wrapper'> 
                    <img src={getIcon('not-started')} alt="dot" />
                </div>
                <div className='wf-steps-section'>
                    <div className='wf-steps-section-title-inactive'>{T.translate('WorkflowLinear.workflowStepTitle_ReturnFiled')}</div>
                </div>
            </div>
        </div>
    );
};

export default WorkflowLinearSteps;